

export const content = {
  app: {
    description: 'A movie and TV information portal',
    title: 'Dollygrip',
  },
  castAndCrew: {
    subTitles: {
      CREATOR: 'Created by',
      DIRECTOR: 'Directed by',
      EXECUTIVE_PRODUCER: 'Exec produced by',
      GUEST_STAR: 'Guest Starring',
      NOVEL: 'Novel',
      PRODUCER: 'Produced by',
      SCREENPLAY: 'Screenplay',
      STAR: 'Starring',
      WRITER: 'Written by',
    },
  },
  categories: {
    continueWatching: 'Continue Watching',
    favorites: 'Favorites',
    recentlyWatched: 'Recently Watched',
    shortcuts: 'Shortcuts',
    watchlist: 'Watchlist',
  },
  cookieConsent: {
    acceptButton: 'I accept',
    content: "**This application uses cookies**\n\nWe use essential cookies to make the app work. We also use additional cookies to analyse site traffic to improve your experience.",
    customiseButton: 'Customise',
  },
  header: {
    closeSearchAriaLabel: 'Close search bar',
    mainMenuAriaLabel: 'Open discover genres menu',
    openSearchAriaLabel: 'Open search bar',
    searchAriaLabel: 'Search for movies, TV shows, cast and crew',
    searchPlaceholder: 'Search...',
  },
  homepage: {
    sections: {
      popularAnimatedMovies: 'Popular Animated Movies',
      popularAnimatedTv: 'Popular Animated TV',
      popularMovies: 'Popular Movies',
      popularNature: 'Popular Nature',
      popularTv: 'Popular TV',
      topRatedAnimatedMovies: 'Top Rated Animated Movies',
      topRatedAnimatedTv: 'Top Rated Animated TV',
      topRatedDocs: 'Top Rated Docs',
      topRatedMovies: 'Top Rated Movies',
      topRatedTv: 'Top Rated TV',
      trending: 'Trending',
    },
  },
  pages: {
    discover: 'Discover',
  },
  reviewsBadge: {
    ariaLabel: 'Open user reviews',
    title: 'Reviews',
  },
  ribbons: {
    movieAndTv: {
      CANCELED: 'Canceled',
      ENDED: 'Ended',
      IN_PRODUCTION: 'In Prod',
      PLANNED: 'Planned',
      POST_PRODUCTION: 'Post Prod',
      RETURNING_SERIES: 'Returning',
      RUMORED: 'Rumored',
    },
    season: {
      airingNow: 'Airing now',
      airs: 'Airs',
    },
  },
  screenTypes: {
    MOVIE: 'Movie',
    TV: 'TV show',
  },
  theMovieDb: {
    disclaimer:
      'This application uses TMDB and the TMDB APIs but is not endorsed, certified, or otherwise approved by TMDB.',
  },
  watchlist: {
    UPCOMING: {
      fallbackContent: "##### Keep on top of upcoming movies and tv shows by adding them to your watchlist\n\nJust select the <AlarmOff /> icon next to the movie or TV show you'd like to keep track of. On tiles, you can add to your watchlist by selecting the <MoreVert /> icon in the top right corner.",
    },
    airDates: {
      CANCELED: {
        fallback: 'Last air date unknown',
        withDate: 'Last aired',
      },
      IN_PRODUCTION: 'Planned for',
      PILOT: {
        fallback: 'Next episode date unknown',
        withDate: 'Next episode',
      },
      PLANNED: 'Planned for',
      RETURNING_SERIES: {
        fallback: 'Next episode date unknown',
        withDate: 'Next episode',
      },
    },
    categories: {
      CANCELED: 'Canceled',
      COMPLETED: 'Released',
      IN_PRODUCTION: 'Shooting',
      PLANNED: 'Planned',
      UPCOMING: 'Upcoming',
    },
    movieReleaseDateFallback: 'No release date',
    releaseDates: {
      CANCELED: 'Was planned for',
      IN_PRODUCTION: 'Planned for',
      PLANNED: 'Planned for',
      POST_PRODUCTION: 'Out',
      RELEASED: 'Released',
      RUMORED: 'Planned for',
      present: 'Present',
    },
    tablist: {
      ariaLabel: 'Watchlist categories',
    },
    tvAirDateFallback: 'No air date',
  },
  watchlistBadge: {
    addAriaLabel: 'Add to watchlist',
    removeAriaLabel: 'Remove from watchlist',
  },
} as const;
